import { shouldAnimate, readEnv, loadGsap, whenNear } from './gm-motion.js';
const run = document.querySelector('[data-gm-run]');
if (run && shouldAnimate(readEnv())) whenNear(run, async () => {
  const { gsap } = await loadGsap().catch(() => ({}));
  if (!gsap) return;
  const riders = [...run.querySelectorAll('.gm-rider')]; if (!riders.length) return;
  run.classList.add('is-live');
  riders.forEach((r, i) => r.style.setProperty('--w', (40 + (i % 3) * 6) + 'vw'));
  const p = run.querySelector('[data-gm-draw]'), L = p.getTotalLength(); p.style.strokeDasharray = L; p.style.strokeDashoffset = L;
  const tl = gsap.timeline({ scrollTrigger: { trigger: run, pin: true, start: 'top top', end: '+=' + (riders.length * 55) + '%', scrub: .5, invalidateOnRefresh: true } });
  tl.to(p, { strokeDashoffset: 0, ease: 'none', duration: 1 }, 0);
  riders.forEach((r, i) => {
    const lane = +r.dataset.lane, spin = +r.dataset.spin;
    tl.fromTo(r, { xPercent: -50 + lane * 180, yPercent: -50, y: () => innerHeight * .9, scale: .55, rotate: -spin },
      { xPercent: -50 - lane * 120, y: () => -innerHeight * .9, scale: 1.2, rotate: spin, ease: 'none', duration: .42 }, i * (0.58 / Math.max(1, riders.length - 1)));
  });
});
